import * as Sentry from '@sentry/react'

Sentry.init({
  environment: import.meta.env.VITE_VERCEL_ENV ?? 'development',
  enabled: import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  sendDefaultPii: true,
  tracesSampleRate: 0,
  normalizeDepth: 6,
  ignoreErrors: [/ChunkLoadError/, /Load failed/],
  tracePropagationTargets: [
    /^https?:\/\/localhost(:\d+)?(\/.*)?$/,
    /^(?!https?:\/\/clerk\.evaro\.com)(https?:\/\/([a-zA-Z0-9-]+\.)*evaro\.com)(\/.*)?$/
  ],
  replaysOnErrorSampleRate: 0,
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click') {
      const text = !hint?.event.target.childElementCount
        ? hint?.event.target.innerText
        : hint.event.target.getAttribute('aria-label')
      if (text) {
        breadcrumb.message = text
      }
    }

    return breadcrumb
  },
  beforeSend(event) {
    event.user = window.Clerk ? (window.Clerk.user as any) : undefined
    event.contexts = {
      ...event.contexts,
      additional_info: {
        isOnline: window.navigator.onLine,
        // @ts-expect-error
        connection: window.navigator.connection?.effectiveType
      },
      store: {}
    }

    event.tags = {
      ...(event.tags ?? {})
    }

    return event
  }
})
